<template>
  <v-container fluid class="pa-0 ma-0">
    <iframe id="company" src="https://www.dataknows.ai/recruit" frameborder="0" />
  </v-container>
</template>

<script>
export default {
  
}
</script>

<style scoped>

#company {
  display: block;
  width: 100vw;
  height: 100vh;

}
</style>